export const MAXIMUM_SIGNED_INT = 2 ** 31 - 1;